import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";

const getYearRange = () => {
	const currentYear = new Date().getFullYear();
	const startYear = currentYear - 10; // 10 years before
	const endYear = currentYear + 5; // 5 years after
	const years: number[] = [];

	for (let year = endYear; year >= startYear; year--) {
		years.push(year);
	}
	return years;
};

export const YearSelector: React.FC<{
	value?: number;
	onYearChange: (year: number) => void;
}> = ({ value, onYearChange }) => {
	const years = getYearRange();

	return (
		<Select
			defaultValue={value?.toString() || "1111"}
			onValueChange={(val) => onYearChange(Number.parseInt(val))}
		>
			<SelectTrigger className="w-[150px] indent-1">
				<SelectValue placeholder="ເລືອກປີ" />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value="1111">ທັງໝົດ</SelectItem>
				{years.map((year) => (
					<SelectItem key={year} value={year.toString()}>
						{year}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
};
